import { useId } from "react";

import type { NavGroup } from "./navItems";
import { isActive } from "./navItems";
import { SidebarItem } from "./SidebarItem";

interface SidebarGroupProps {
  group: NavGroup;
  pathname: string;
  unread: number;
  compact: boolean;
  onNavigate?: (() => void) | undefined;
}

export function SidebarGroup({
  group,
  pathname,
  unread,
  compact,
  onNavigate,
}: SidebarGroupProps) {
  const labelId = useId();
  return (
    <div className="mb-3.5">
      {compact ? (
        <span id={labelId} className="sr-only">
          {group.label}
        </span>
      ) : (
        <p id={labelId} className="eyebrow text-rail-muted px-3 py-1.5">
          {group.label}
        </p>
      )}
      <ul aria-labelledby={labelId} className="space-y-0.5">
        {group.items.map((item) => (
          <li key={item.key}>
            <SidebarItem
              item={item}
              active={item.href !== null && isActive(item.href, pathname)}
              count={item.badge === "unread" ? unread : 0}
              compact={compact}
              onNavigate={onNavigate}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
